// extracted by mini-css-extract-plugin
export var lbContainerOuter = "v_tC";
export var lbContainerInner = "v_tD";
export var movingForwards = "v_tF";
export var movingForwardsOther = "v_tG";
export var movingBackwards = "v_tH";
export var movingBackwardsOther = "v_tJ";
export var lbImage = "v_tK";
export var lbOtherImage = "v_tL";
export var prevButton = "v_tM";
export var nextButton = "v_tN";
export var closing = "v_tP";
export var appear = "v_tQ";